module.exports = __webpack_public_path__ + "img/logo_2.da2284f1.png";